import Switch from 'components/Switch';
import { usePhotoGalleryContainer } from '..';

const options = ['Thumbnails', 'Slideshow'];

export default function PhotoGallerySwitch() {
  const [{ slideshowIsOpen }, { handleSwitchClick }] = usePhotoGalleryContainer();

  return <Switch options={options} value={slideshowIsOpen ? options[1] : options[0]} onChange={handleSwitchClick} />;
}
